export const average = data => {
  const sum = data.reduce((sum, value) => {
    return sum + value;
  }, 0);

  return sum / data.length;
};

export const fixed = (number, precision = 2) => {
  return Number(number.toFixed(precision));
};



// WEBPACK FOOTER //
// ./src/utilities/math.js